"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCssPropertyValue = exports.esc_html = exports.wait = void 0;
/* ========================================================================
    Module: Util
 ========================================================================== */
/**
 * 疑似 sleep 処理
 *
 * @param {number} ms
 * @returns {Promise<unknown>}
 */
const wait = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};
exports.wait = wait;
/**
 * HTML エスケープを行う
 *
 * @param {T} string
 * @returns {string | T}
 */
const esc_html = (string) => {
    if (typeof string !== "string") {
        return string;
    }
    return string.replace(/[&'`"<>]/g, (match) => {
        const result = {
            "&": "&amp;",
            "'": "&#x27;",
            "`": "&#x60;",
            '"': "&quot;",
            "<": "&lt;",
            ">": "&gt;",
        }[match];
        return result ?? string;
    });
};
exports.esc_html = esc_html;
/**
 * CSS プロパティの値を取得する
 *
 * @param {string} name
 * @returns {string}
 */
const getCssPropertyValue = (name) => {
    return getComputedStyle(document.documentElement).getPropertyValue(name);
};
exports.getCssPropertyValue = getCssPropertyValue;
